import { render } from "./Miliestone.vue?vue&type=template&id=2e4a3d0c"
import script from "./Miliestone.vue?vue&type=script&lang=js"
export * from "./Miliestone.vue?vue&type=script&lang=js"

import "./Miliestone.vue?vue&type=style&index=0&id=2e4a3d0c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__